/**
 * Default jsonp provider
 * @module
 */
var JSONP = require('../sources/jsonp');

/**
 * Given a vendor, return a VisitorProfileProvider that:
 *
 * * isAsync
 * * Builds a JSONP url from integration settings for that vendor (url, cbParam properties)
 * * Makes a JSONP request to that url with the callback name set to {vendor}
 *
 * @param {string} vendor
 * @returns {VisitorProfileProvider}
 */
module.exports = function(vendor:string): VisitorProfileProvider {
  return {
    isAsync: true,

    getter: [
      'stores/integration_settings',
      /**
       *
       * @param {module:stores/integration_settings} IntegrationSettings
       * @returns {Promise}
       */
      function(IntegrationSettings) {
        var config = IntegrationSettings.get(vendor);
        var url = JSONP.buildURL(config.url, config.cbParam);
        return JSONP.fetchData(vendor, url);
      },
    ],
  };
};
